<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="phase"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Fase"
        label-for="phase"
        class="mb-0"
      >
        <v-select
          id="phase"
          v-model="phase"
          :class="errors.length > 0 ? 'error-select' : ''"
          :filter="fuseSearch"
          label="name"
          :options="dataOptions"
          :placeholder="'Fase'"
          :disabled="readonly"
          :clearable="!readonly"
          @open="onCreate()"
        >
          <template #option="{ name }">
            <span>{{ name }} </span>
          </template>

          <template #selected-option="{ name }">
            <span class="d-xl-flex d-none">{{ name | truncate(17, '...') }}</span>
            <span class="d-lg-flex d-xl-none d-sm-none d-none">{{ name | truncate(14, '...') }}</span>
            <span class="d-md-flex d-lg-none d-sm-none d-none">{{ name | truncate(19, '...') }}</span>
            <span class="d-md-none">{{ name | truncate(25, '...') }}</span>
          </template>

          <template #no-options>
            Não há opções de fases.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import syslic from '@/syslic'
import truncate from '@/components/utils/filters/truncate'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'phaseValue',
    event: 'phaseChange',
  },
  props: {
    phaseValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const dataOptions = []

    return {
      dataOptions,
      required,
    }
  },
  computed: {
    phase: {
      get() {
        return this.phaseValue
      },
      set(value) {
        this.$emit('phaseChange', value)
      },
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .bidding
        .phase
        .fetchPhases()
        .then(response => {
          this.dataOptions = response.data.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}
</style>
